import { isOperation } from "../../typeGuards";
import {
  ARSTActionDropAction,
  ArsTableCellData,
  ArsTableSidebarItemKind,
  ArsTableState,
} from "../interface";
import { arst_addOperationsToGroup } from "./arst_addOperationsToGroup";
import { arst_operationToTableGroup } from "./arst_arsToTableGroup";

/**
 * Adds dropped operations to the resolved target group in the ARS table state.
 *
 * @param state - Current ARS table state
 * @param action - Drop action describing the target cell and dropped operations
 * @returns Updated ARS table state
 */
export const arst_addOperationToGroup = <T>(
  state: ArsTableState<T>,
  action: ARSTActionDropAction,
): ArsTableState<T> => {
  const targetCell: ArsTableCellData<T> | undefined =
    state.scaffoldModel?.cellData[action.rowId]?.[action.columnId];
  if (!targetCell) return state;

  const newOperations = action.payload
    .flatMap((item) =>
      item.kind === ArsTableSidebarItemKind.AnalysisMethod
        ? item.dropItem.operations
        : [item.dropItem],
    )
    .filter(isOperation)
    .map((operation) => arst_operationToTableGroup(operation, state.settings.editorProps));
  const newBodyData = arst_addOperationsToGroup(
    state.bodyData,
    targetCell.dataPath,
    newOperations,
    state.settings.editorProps.isT,
  );
  if (!newBodyData) return state;

  return {
    ...state,
    bodyData: newBodyData,
    changed: true,
  };
};
